import { clinicianMaxUpgradeModalOpenAtom } from '@/atoms/paywallAtoms';
import { useAtomValue } from 'jotai';
import dynamic from 'next/dynamic';

const ClinicianMaxUpgradeModalImplementation = dynamic(
  () =>
    import('./clinician-max-upgrade-modal-implementation').then(
      (mod) => mod.ClinicianMaxUpgradeModalImplementation
    ),
  { ssr: false, loading: () => null }
);

/** Self-gated Clinician Max upgrade modal (lazy Pattern B). */
export function ClinicianMaxUpgradeModal() {
  const isOpen = useAtomValue(clinicianMaxUpgradeModalOpenAtom);

  if (!isOpen) {
    return null;
  }

  return <ClinicianMaxUpgradeModalImplementation />;
}
